import { IDeleteCadastroCoresUseCase } from "../../../presentation/useCases/delete/delete_cadastro_cores_use_case";
import { IEquipamentoMedicaoRepository } from "../../repositories/EquipamentoMedicao_Repositorie";

/**
 * DeleteCadastroCoresUseCase
 */

export class DeleteCadastroCoresUseCase implements IDeleteCadastroCoresUseCase {
  constructor(private readonly repository: IEquipamentoMedicaoRepository) { }

  async deleteCadastroCores(
    idCadastroCor: number,
  ): Promise<void> {
    await this.repository.deleteCadastroCores(idCadastroCor);
  }
}
